import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "app/store";

import {
  ACCOUNT_RECEIVABLE_DEFAULT_FILTERS,
  AccountReceivableCustomFiltersValues
} from "./use-invoices-receivable-custom-filter-options.hook";

interface InvoicesReceivableFiltersState {
  before_moment: string | null;
  after_moment: string | null;
  selectedCustomFilters: AccountReceivableCustomFiltersValues;
  snapshot: boolean;
  opening_balance: string | undefined;
  selectedDateRangeType: "service-date" | "delivery-date";
}

const initialState: InvoicesReceivableFiltersState = {
  before_moment: null,
  after_moment: null,
  selectedCustomFilters: ACCOUNT_RECEIVABLE_DEFAULT_FILTERS,
  snapshot: false,
  opening_balance: undefined,
  selectedDateRangeType: "service-date" as const
};

const invoicesReceivableFiltersSlice = createSlice({
  name: "invoicesReceivableFilters",
  initialState,
  reducers: {
    setDateRange(
      state,
      action: PayloadAction<{
        before_moment: string | null;
        after_moment: string | null;
      }>
    ) {
      state.before_moment = action.payload.before_moment;
      state.after_moment = action.payload.after_moment;
    },
    setSelectedCustomFilter(
      state,
      action: PayloadAction<{ field: string; value: any }>
    ) {
      (state.selectedCustomFilters as any)[action.payload.field] =
        action.payload.value;
    },
    setAllCustomFilters(
      state,
      action: PayloadAction<AccountReceivableCustomFiltersValues>
    ) {
      state.selectedCustomFilters = action.payload;
    },
    setSnapshot(state, action: PayloadAction<boolean>) {
      state.snapshot = action.payload;
    },
    setOpeningBalance(state, action: PayloadAction<string | undefined>) {
      state.opening_balance = action.payload;
    },
    setDateRangeType(state, action: PayloadAction<"service-date" | "delivery-date">) {
      state.selectedDateRangeType = action.payload;
    }
  }
});

export const selectInvoicesReceivableFilters = (state: RootState) =>
  state.invoicesReceivableFilters;

export const {
  setDateRange,
  setSelectedCustomFilter,
  setAllCustomFilters,
  setSnapshot,
  setOpeningBalance,
  setDateRangeType
} = invoicesReceivableFiltersSlice.actions;

export default invoicesReceivableFiltersSlice.reducer;
